<template>
  <v-container class="search-page">
    <div v-if="is_small_screen">
      <v-row>
        <v-col cols="12" lg="3">
          <Button
            style="width: 100%"
            title="Filtrez vos recherches"
            class="search-button mb-2"
            @click.native="searchdrawer = !searchdrawer"
            sizeText="small_text"
          />
          <!-- <v-btn
            color="primary"
            class="filesearch-btn"
            @click="searchdrawer = !searchdrawer"
          >
            <span class="text-none">Filtrez vos recherches</span>
          </v-btn>-->
        </v-col>
        <v-col cols="12" lg="9">
          <p class="simple_text" v-html="numberOfMatch" />
        </v-col>
      </v-row>
    </div>
    <v-navigation-drawer
      fixed
      right
      class="nav-drawer"
      v-model="searchdrawer"
      v-if="is_small_screen"
    >
      <SearchNavBarPanelCheckboxes />
    </v-navigation-drawer>
    <v-row justify="center">
      <v-col cols="3" v-if="!is_small_screen" class="search-criteria">
        <div>
          <SearchNavBarPanelCheckboxes />
        </div>
      </v-col>
      <v-col cols="12" md="9">
        <div v-if="!is_small_screen">
          <p class="simple_text" v-html="numberOfMatch" />
        </div>
        <v-sheet class="body-sheet">
          <div>
            <SearchCard
              class="clickable"
              v-for="item in getBiens"
              :key="item.id"
              link
              :props_data="item"
            />
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped></style>

<script>
import { mapGetters } from "vuex";
import SearchCard from "../components/search/SearchCard";
import SearchNavBarPanelCheckboxes from "../components/search/SearchNavBarPanelCheckboxes";
import Button from "@/components/HomeSections/SubComponents/Button";

export default {
  name: "SearchView",
  props: ["id"],
  components: {
    SearchCard,
    SearchNavBarPanelCheckboxes,
    Button
  },
  data() {
    return {
      searchdrawer: false,
      screen_size: 800,
      nbFetch: 0
    };
  },

  computed: {
    ...mapGetters({
      getBiens: "biensModule/getBiens"
    }),
    is_small_screen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        case "lg":
        case "xl":
          return false;
      }
      return false;
    },
    getBiensLength() {
      return this.getBiens.length;
    },
    numberOfMatch() {
      if (this.getBiens.length == 1) {
        return "<b>1</b> bien correspond à vos critères de recherches";
      }
      return `<b>${this.getBiens.length}</b> biens correspondent à vos critères de recherches`;
    }
  },

  methods: {},

  beforeMount() {
    this.screen_size = window.height;
  }
};
</script>

<style scoped>
.container {
  max-width: none !important;
}

.filesearch-btn {
  padding: 10px 0px !important;
}

@media (max-width: 978px) {
  .search-page {
    padding: 10px !important;
    background-color: #fafefe !important;
  }
}

.search-page {
  padding: 50px;
  background-color: #fafefe !important;
}

.search-criteria {
  border-radius: 15px;
  background-color: white !important;
}

.body-sheet {
  background-color: #fafefe !important;
}

.nav-drawer {
  padding-top: 100px;
}
</style>
